export const utcToString = (date) => new Date(date * 1000).toLocaleDateString();

export default utcToString;
